import Render from "components/Common/Render";
import RenderAttribute from "components/PayoutManagement/previews/RenderAttribute";
import { PayoutMethodType } from "containers/PayoutManagement/types";
import React from "react";

interface IZellePreviewProps {
  defaultPayoutMethod: PayoutMethodType;
}

const ZellePreview: React.FC<IZellePreviewProps> = ({
  defaultPayoutMethod,
}) => {
  return (
    <div>
      <Render when={!!defaultPayoutMethod.phoneNumber}>
        <RenderAttribute
          label={"Phone Number: "}
          value={defaultPayoutMethod.phoneNumber}
        />
      </Render>
      <Render when={!!defaultPayoutMethod.email}>
        <RenderAttribute label={"Email: "} value={defaultPayoutMethod.email} />
      </Render>
    </div>
  );
};

export default ZellePreview;
